import parseCompareItems from './parse-compare-items.js';
import { compareItemsLSKey } from '../../../configuration/index.js';

/** @typedef {import('./typedefs.js').CompareItems} CompareItems */

/**
 * Get compare items from localStorage
 * @returns {CompareItems}
 */
export default function getCompareItems() {
  return parseCompareItems(localStorage.getItem(compareItemsLSKey));
}
